import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { mapUserSlidesToPortalRewards } from "@/data/portal_rewards_slides_mappers";

export function usePortalRewardsSlides() {
  const store = useStore();
  const { locale } = useI18n();

  const loading = computed(() => store.getters.getSliderIsLoading);

  const rewardSlides = computed(() =>
    mapUserSlidesToPortalRewards(store.getters.getUserSlides, locale.value),
  );

  return {
    rewardSlides,
    loading,
  };
}
